export default "__VITE_ASSET__DnZMM65K__"